import _get from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/get.js";
import _createClass from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _inherits from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/builds/everlywell/apps/www/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Base, WordArray } from './core.js';
var X32WordArray = WordArray;
/**
 * A 64-bit word.
 */

export var X64Word = /*#__PURE__*/function (_Base) {
  _inherits(X64Word, _Base);

  var _super = _createSuper(X64Word);

  /**
   * Initializes a newly created 64-bit word.
   *
   * @param {number} high The high 32 bits.
   * @param {number} low The low 32 bits.
   *
   * @example
   *
   *     var x64Word = CryptoJS.x64.Word.create(0x00010203, 0x04050607);
   */
  function X64Word(high, low) {
    var _this;

    _classCallCheck(this, X64Word);

    _this = _super.call(this);
    _this.high = high;
    _this.low = low;
    return _this;
  }

  return _createClass(X64Word);
}(Base);
/**
 * An array of 64-bit words.
 *
 * @property {Array} words The array of CryptoJS.x64.Word objects.
 * @property {number} sigBytes The number of significant bytes in this word array.
 */

export var X64WordArray = /*#__PURE__*/function (_Base2) {
  _inherits(X64WordArray, _Base2);

  var _super2 = _createSuper(X64WordArray);

  /**
   * Initializes a newly created word array.
   *
   * @param {Array} words (Optional) An array of CryptoJS.x64.Word objects.
   * @param {number} sigBytes (Optional) The number of significant bytes in the words.
   *
   * @example
   *
   *     var wordArray = CryptoJS.x64.WordArray.create();
   *
   *     var wordArray = CryptoJS.x64.WordArray.create([
   *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
   *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
   *     ]);
   *
   *     var wordArray = CryptoJS.x64.WordArray.create([
   *         CryptoJS.x64.Word.create(0x00010203, 0x04050607),
   *         CryptoJS.x64.Word.create(0x18191a1b, 0x1c1d1e1f)
   *     ], 10);
   */
  function X64WordArray() {
    var _this2;

    var words = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var sigBytes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : words.length * 8;

    _classCallCheck(this, X64WordArray);

    _this2 = _super2.call(this);
    _this2.words = words;
    _this2.sigBytes = sigBytes;
    return _this2;
  }
  /**
   * Converts this 64-bit word array to a 32-bit word array.
   *
   * @return {CryptoJS.lib.WordArray} This word array's data as a 32-bit word array.
   *
   * @example
   *
   *     var x32WordArray = x64WordArray.toX32();
   */


  _createClass(X64WordArray, [{
    key: "toX32",
    value: function toX32() {
      // Shortcuts
      var x64Words = this.words;
      var x64WordsLength = x64Words.length; // Convert

      var x32Words = [];

      for (var i = 0; i < x64WordsLength; i += 1) {
        var x64Word = x64Words[i];
        x32Words.push(x64Word.high);
        x32Words.push(x64Word.low);
      }

      return X32WordArray.create(x32Words, this.sigBytes);
    }
    /**
     * Creates a copy of this word array.
     *
     * @return {X64WordArray} The clone.
     *
     * @example
     *
     *     var clone = x64WordArray.clone();
     */

  }, {
    key: "clone",
    value: function clone() {
      var clone = _get(_getPrototypeOf(X64WordArray.prototype), "clone", this).call(this); // Clone "words" array


      clone.words = this.words.slice(0);
      var words = clone.words; // Clone each X64Word object

      var wordsLength = words.length;

      for (var i = 0; i < wordsLength; i += 1) {
        words[i] = words[i].clone();
      }

      return clone;
    }
  }]);

  return X64WordArray;
}(Base);